import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container } from '@mui/material';
// components
import Page from '../components/Page';
//
import { MaintenanceIllustration } from '../assets';
import Logo from 'src/components/Logo';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function Maintenance() {
  return (
    <Page title="سامانه لبیک" sx={{ height: 1 }}>
      <RootStyle>
        <Container sx={{ textAlign: 'center' }}>
        <img
          src={'/icons/logo.svg'}
          alt={'logo'}
          style={{
            width :200,
            margin:"auto",
            marginBottom : 16,
          }}
        />
          <Typography variant="h3" paragraph>
            هیچ سفر فعالی وجود ندارد
          </Typography>
          {/* <Typography sx={{ color: 'text.secondary' }}>We are currently working hard on this page!</Typography> */}

          {/* <MaintenanceIllustration sx={{ my: 10, height: 240 }} /> */}

        </Container>
      </RootStyle>
    </Page>
  );
}
